import React from 'react';
import { UrgencyBar } from '../components/UrgencyBar';
import { HeroSection } from '../components/HeroSection';
import { AgitationSection } from '../components/AgitationSection';
import { SolutionSection } from '../components/SolutionSection';
import { BenefitsSection } from '../components/BenefitsSection';
import { OfferSection } from '../components/OfferSection';
import { GuaranteeSection } from '../components/GuaranteeSection';
import { FAQSection } from '../components/FAQSection';
import { FinalCTA } from '../components/FinalCTA';
export function SalesPage() {
  return <div className="min-h-screen bg-holistic-cream font-sans text-holistic-earth selection:bg-holistic-sage selection:text-white" data-id="element-195">
      <UrgencyBar data-id="element-196" />
      <main data-id="element-197">
        <HeroSection data-id="element-198" />
        <AgitationSection data-id="element-199" />
        <SolutionSection data-id="element-200" />
        <BenefitsSection data-id="element-201" />
        <OfferSection data-id="element-202" />
        <GuaranteeSection data-id="element-203" />
        <FAQSection data-id="element-204" />
        <FinalCTA data-id="element-205" />
      </main>
      <footer className="bg-holistic-earth-light text-holistic-sand/60 py-8 text-center text-sm" data-id="element-206">
        <div className="max-w-4xl mx-auto px-6" data-id="element-207">
          <p data-id="element-208">
            © {new Date().getFullYear()} Código de Autocuración. Todos los
            derechos reservados.
          </p>
          <p className="mt-2 text-xs opacity-70" data-id="element-209">
            Este producto no sustituye el consejo médico profesional. Consulte
            siempre a su médico antes de comenzar cualquier programa de salud.
          </p>
        </div>
      </footer>
    </div>;
}